import { createSelector } from 'reselect';
import { CustomerProps } from 'utils';

export const websiteSelector = createSelector(
  (state) => state.d_website,
  (website) => website
);

export const getCustomerSelector = createSelector(websiteSelector, (website) => {
  if (CustomerProps.DGUV.ctIds.includes(`${website.id}`)) {
    return CustomerProps.DGUV;
  }

  if (CustomerProps.UIT.ctIds.includes(`${website.id}`)) {
    return CustomerProps.UIT;
  }

  if (CustomerProps.GBA.ctIds.includes(`${website.id}`)) {
    return CustomerProps.GBA;
  }
});

export const getPlayerAnalyticsConsentSelector = createSelector(
  websiteSelector,
  (website) => website.gavePlayerAnalyticsConsent
);
